import {graphql} from '@apollo/client/react/hoc';
import gql from 'graphql-tag';

import queryUtils from "utils/queryUtils";

const RolesWithUsersQuery = gql`
  query RolesWithUsersQuery {
    rolesWithUsers {
      id
      name
      users {
        id
        name
        email
      }
    }
  }
`;


const GhostEmbedImagesQuery = gql`
  query GhostEmbedImagesQuery {
    ghostEmbedImages {
      id
      licenseId
      eventId
      scenarioId
      thumbnail
      events {
        id
        licenseId
        name
      }
      scenarios {
         id
         eventId
         name
      }
    }
  }
`;


export const licenseTemplateFields = `
  id
  name
  prefix
  durationMonths
  studentsLimit
  eventsLimit
  dataLimit
  comments
  catalogs {
    id
    name
  }
`;

const LicenseTemplatesQuery = gql`
  query LicenseTemplatesQuery {
    licenseTemplates {
      ${licenseTemplateFields}
    }
  }
`;


export const deviceFields = `
  id
  name
  nameMl
  description
  descriptionMl
  createdAt
  modifiedAt
  parameters
`;

const ServiceDevicesQuery = gql`
  query ServiceDevicesQuery {
    serviceDevices {
      ${deviceFields}
    }
  }
`;


const ServiceUsersQuery = gql`
  query ServiceUsersQuery($search: String!) {
    serviceUsers(search: $search) {
      id
      name
      email
      talentId
      active
      parameters
      licenses {
        id
        name
        events {
          id
          name
          isArchived
          studentGroupAssignment {
            id
            studentId
            studentGroupId
          }
        }
      }
    }
  }
`;


const LogsQuery = gql`
  query LogsQuery($expression: String) {
    logs(expression: $expression) {
      id
      authorId
      objectType
      objectId
      level
      message
      parameters
      createdAt
    }
  }
`;



export const queryRolesWithUsers =
    graphql(RolesWithUsersQuery, {
        options: {
            fetchPolicy: 'network-only' },
        props: ({ ownProps, data }) => ({
            loading: queryUtils.mergeWith(ownProps.loading, {rolesWithUsers: data.loading}),
            errors: queryUtils.mergeWith(ownProps.errors, {rolesWithUsers: data.error && data.error.message}),
            rolesWithUsers: data.rolesWithUsers
        })
    });


export const queryGhostEmbedImages =
    graphql(GhostEmbedImagesQuery, {
        options: {
            fetchPolicy: 'network-only' },
        props: ({ ownProps, data }) => ({
            loading: queryUtils.mergeWith(ownProps.loading, {ghostEmbedImages: data.loading}),
            errors: queryUtils.mergeWith(ownProps.errors, {ghostEmbedImages: data.error && data.error.message}),
            ghostEmbedImages: data.ghostEmbedImages
        })
    });


export const queryLicenseTemplates =
    graphql(LicenseTemplatesQuery, {
        options: {
            fetchPolicy: 'network-only' },
        props: ({ ownProps, data }) => ({
            loading: queryUtils.mergeWith(ownProps.loading, {licenseTemplates: data.loading}),
            errors: queryUtils.mergeWith(ownProps.errors, {licenseTemplates: data.error && data.error.message}),
            licenseTemplates: data.licenseTemplates
        })
    });


export const queryServiceDevices =
    graphql(ServiceDevicesQuery, {
        options: {
            fetchPolicy: 'network-only' },
        props: ({ ownProps, data }) => ({
            loading: queryUtils.mergeWith(ownProps.loading, {serviceDevices: data.loading}),
            errors: queryUtils.mergeWith(ownProps.errors, {serviceDevices: data.error && data.error.message}),
            serviceDevices: data.serviceDevices
        })
    });


export const queryServiceUsers =
    graphql(ServiceUsersQuery, {
        options: ({search}) => ({
            variables: {search: search},
            fetchPolicy: 'network-only' }),
        skip: ({search}) => !search,
        props: ({ ownProps, data }) => ({
            loading: queryUtils.mergeWith(ownProps.loading, {users: data.loading}),
            errors: queryUtils.mergeWith(ownProps.errors, {users: data.error && data.error.message}),
            serviceUsers: data.serviceUsers
        })
    });


export const queryLogs =
    graphql(LogsQuery, {
        options: ({expression}) => ({
            variables: {expression: expression},
            fetchPolicy: 'network-only' }),
        props: ({ ownProps, data }) => ({
            loading: queryUtils.mergeWith(ownProps.loading, {logs: data.loading}),
            errors: queryUtils.mergeWith(ownProps.errors, {logs: data.error && data.error.message}),
            logs: data.logs
        })
    });